import { render, staticRenderFns } from "./purchaseOrderShowShipment.vue?vue&type=template&id=4d3121f6&scoped=true&"
import script from "./purchaseOrderShowShipment.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderShowShipment.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrderShowShipment.vue?vue&type=style&index=0&id=4d3121f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3121f6",
  null
  
)

export default component.exports